<app-subnavegacion
  opcion1="renac"
  opcion2="renec"
></app-subnavegacion>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<div class="container">
  <div class="row"></div>

  <div class="title-container">
    <b class="title"
      >RENAP - REGISTRO NACIONAL DE PERSONAS CON COMPETENCIAS CERTIFICADAS</b
    >
  </div>

  <app-renap-table-principal
    *ngIf="!selectedCourse"
    (courseSelected)="onCourseSelected($event)"
  ></app-renap-table-principal>
</div>
